import { Box, Typography } from "src/components";
import { useState, useEffect, useRef } from "react";

import logo from 'src/assets/logo-rect.png'; 
import posterImage from 'src/assets/placeholders/light-grey-1080x1480.png'; 

export default function TutorialScreens({ data, step }) {
    const [videoError, setVideoError] = useState(false);
    const videoRef = useRef(null);

    const currentVideo = videoError ? null : data[step].mp4;

    // Reset error and play video when step changes
    useEffect(() => {
        setVideoError(false);
        const v = videoRef.current;
        if (v) {
            v.load(); // reload the new video
            v.play().catch(() => {});
        }
    }, [step]);

    return (
        <Box
            sx={{
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
            }}
            >
            {/* Logo at top */}
            <Box
                component="img"
                src={logo}
                alt="Logo"
                sx={{
                height: 64,
                mb: 2,
                flexShrink: 0,
                alignSelf: "center",
                }}
            />

            {/* Video container with fixed aspect ratio */}
            <Box
                sx={{
                    flexGrow: 1,
                    width: "100%",
                    position: "relative",
                    borderRadius: 2,
                    overflow: "hidden",
                    backgroundColor: "#fff", 
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
                >
                {currentVideo && (
                    <video
                        ref={videoRef}
                        src={currentVideo}
                        autoPlay
                        muted
                        loop
                        playsInline
                        preload="auto"
                        poster={posterImage}
                        onError={() => setVideoError(true)}
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain", 
                            display: "block",
                            backgroundColor: "#fff", 
                        }}
                    />
                )}
            </Box>

            {/* Tutorial message */}
            <Box
                sx={{
                position: "sticky",
                bottom: 0,
                backgroundColor: "#fff",
                mx: -2,
                my: -1,
                py: 1,
                }}>
                <Typography
                    variant="subtitle1"
                    sx={{
                        textAlign: "center",
                        px: 2,
                        mt: 1,
                        flexShrink: 0,
                        wordWrap: "break-word",
                        lineHeight: "16px",
                    }}>
                        {data[step].message}
                </Typography>
            </Box>
        </Box>
    );
}
